import { SubEmpresaDetail } from './../types'
import { subEmpresaRepository } from './subEmpresaRepository'

import { makeUseList } from '@elentari/core'

export const useSubEmpresas = makeUseList<SubEmpresaDetail>(subEmpresaRepository.fetch)
